import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { HttpErrorResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { map, catchError } from 'rxjs/operators';
import { throwError } from 'rxjs';
import { tap } from 'rxjs/operators';

import { Config } from '../../config/config';
@Injectable({
  providedIn: 'root'
})
export class CtbConfService {
  dataUrl = Config.URL_BASE;
  constructor(private http: HttpClient) {

  }

  post(dto: CtbConfEmp): Observable<any> {
    let url_ = this.dataUrl + '/ctbConfEmp/post';
    url_ = url_.replace(/[?&]$/, '');
    return this.http.post(url_, dto).pipe(
      catchError(e => {
        console.log(e);
        return throwError(e);
      })
    );
  }
  getMonByEmpId(id: number): Observable<any> {
    let url_ = this.dataUrl + '/gralmon/get/byEmp/' + id;
    url_ = url_.replace(/[?&]$/, '');
    return this.http.get(url_).pipe(
      catchError(e => {
        console.log(e);
        return throwError(e);
      })
    );
  }
  put(dto: CtbConfEmp): Observable<any> {
    let url_ = this.dataUrl + '/ctbConfEmp/put';
    url_ = url_.replace(/[?&]$/, '');
    return this.http.put(url_, dto).pipe(
      catchError(e => {
        console.log(e);
        return throwError(e);
      })
    );
  }
  actualizarPeriodo(dto: CtbConfEmp, idSuc: number): Observable<any> {
    let url_ = this.dataUrl + '/ctbConfEmp/put/' + idSuc;
    url_ = url_.replace(/[?&]$/, '');
    return this.http.put(url_, dto).pipe(
      catchError(e => {
        console.log(e);
        return throwError(e);
      })
    );
  }
  delete(id: number, idUsr: number): Observable<any> {
    const url_ = this.dataUrl + '/ctbConfEmp/delete/' + id + '/' + idUsr;
    return this.http.delete(url_).pipe(
      catchError(e => {
        console.log(e);
        return throwError(e);
      })
    );
  }
  catalogo(criterio: PageBusquedaObject): Observable<any> {
    let url_ = this.dataUrl + '/ctbConfEmp/catalogo';
    url_ = url_.replace(/[?&]$/, '');
    return this.http.post(url_, criterio).pipe(
      catchError(e => {
        console.log(e);
        return throwError(e);
      })
    );
  }
  find(criterio: PageBusquedaObject): Observable<any> {
    let url_ = this.dataUrl + '/gral_emp/busqueda';
    url_ = url_.replace(/[?&]$/, '');
    return this.http.post(url_, criterio).pipe(
      catchError(e => {
        console.log(e);
        return throwError(e);
      })
    );
  }
  getCta(id: number): Observable<any> {
    let url_ = this.dataUrl + '/ctbConfEmp/get/' + id;
    url_ = url_.replace(/[?&]$/, '');
    return this.http.get(url_).pipe(
      catchError(e => {
        console.log(e);
        return throwError(e);
      })
    );
  }
  

  getByEmpId(id: number): Observable<any> {
    let url_ = this.dataUrl + '/ctbConfEmp/get/by/emp/' + id;
    url_ = url_.replace(/[?&]$/, '');
    return this.http.get(url_).pipe(
      catchError(e => {
        console.log(e);
        return throwError(e);
      })
    );
  }
  getCatalogoPreinstalado(): Observable<any> {
    let url_ = this.dataUrl + '/ctbConfEmp/get/catalogo/preinstalado';
    url_ = url_.replace(/[?&]$/, '');
    return this.http.get(url_).pipe(
      catchError(e => {
        console.log(e);
        return throwError(e);
      })
    );
  }
}
export class CtbConfEmp {
  id: number;
  rfc: String | undefined = '';
  nombre: String | undefined = '';
  catalogo: String | undefined = '';
  estructura: String | undefined = '3-2-3';
  estructura1: String | undefined = 'XXX-XX-XXX';
  fecha_inicio: string;
  fecha_fin: string;
  tipo_cierre: number | undefined = 2;
  periodo: number | undefined = 1;
  catalogoPresente: boolean;
  numero_periodos: number | undefined = 12;
  periodo_vigente: number | undefined = 1;
  al: string;
  obligarAsignarSat: boolean | undefined = true;
  cierre_anual: boolean | undefined = true;
  del: string;
  momento_crea: String;
  momento_actualiza: String;
  momento_baja: String;
  gralUsrCreaId: number;
  gralUsrActualizaId: number;
  gralUsrBajaId: number;
  emp: GralEmp;
}
export class CtbCtaDefault {
  id: number;
  titulo: String;
}
export class GralEmp {
  id?: number;
  titulo?: String | null | undefined = '';
  rfc?: String | null | undefined = '';
  nombre_comercial: String | null | undefined = '';
  seleccionado?: boolean;
  suc?: any;
}
export class PageBusquedaObject {
  column?: string | undefined;
  criteriaSearch?: any | undefined;
  itemsPerPage?: number | undefined;
  order?: string | undefined;
  pageNumber?: number | undefined;
  sort?: boolean | undefined;
}
